import { sortArrayParams } from '@entities/Auto/module/types/autoSelectsTypes';

export const sortParamsRecSizes = (a, b) => sortArrayParams.indexOf(a.code) - sortArrayParams.indexOf(b.code);
